/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameBarcodeDatamatrixIcon16Light } from './ScanFrameBarcodeDatamatrixIcon16Light';
import { ScanFrameBarcodeDatamatrixIcon16Regular } from './ScanFrameBarcodeDatamatrixIcon16Regular';
import { ScanFrameBarcodeDatamatrixIcon16Solid } from './ScanFrameBarcodeDatamatrixIcon16Solid';
import { ScanFrameBarcodeDatamatrixIcon20Light } from './ScanFrameBarcodeDatamatrixIcon20Light';
import { ScanFrameBarcodeDatamatrixIcon20Regular } from './ScanFrameBarcodeDatamatrixIcon20Regular';
import { ScanFrameBarcodeDatamatrixIcon20Solid } from './ScanFrameBarcodeDatamatrixIcon20Solid';
import { ScanFrameBarcodeDatamatrixIcon24Regular } from './ScanFrameBarcodeDatamatrixIcon24Regular';
import { ScanFrameBarcodeDatamatrixIcon24Solid } from './ScanFrameBarcodeDatamatrixIcon24Solid';
import { ScanFrameBarcodeDatamatrixIcon32Regular } from './ScanFrameBarcodeDatamatrixIcon32Regular';
import { ScanFrameBarcodeDatamatrixIcon64Regular } from './ScanFrameBarcodeDatamatrixIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameBarcodeDatamatrixIcon16Light,
        regular: ScanFrameBarcodeDatamatrixIcon16Regular,
        solid: ScanFrameBarcodeDatamatrixIcon16Solid,
    },
    20: {
        light: ScanFrameBarcodeDatamatrixIcon20Light,
        regular: ScanFrameBarcodeDatamatrixIcon20Regular,
        solid: ScanFrameBarcodeDatamatrixIcon20Solid,
    },
    24: {
        regular: ScanFrameBarcodeDatamatrixIcon24Regular,
        solid: ScanFrameBarcodeDatamatrixIcon24Solid,
    },
    32: {
        regular: ScanFrameBarcodeDatamatrixIcon32Regular,
    },
    64: {
        regular: ScanFrameBarcodeDatamatrixIcon64Regular,
    },
};
export var ScanFrameBarcodeDatamatrixIcon = forwardRef('ScanFrameBarcodeDatamatrixIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
